import api from '../../utils/axios';

export const voucherService = {
  // Get all vouchers for the logged-in agent
  getVouchers: async () => {
    const response = await api.get('/agent/vouchers');
    return response.data;
  },

  // Get a single voucher by ID
  getVoucherById: async (id) => {
    const response = await api.get(`/agent/vouchers/${id}`);
    return response.data;
  },

  // Save new voucher (create)
  createVoucher: async (formData) => {
    const response = await api.post('/agent/save-voucher', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Update existing voucher
  updateVoucher: async (id, data, isMultipart = false) => {
    let payload = data;
    let headers = isMultipart ? { 'Content-Type': 'multipart/form-data' } : undefined;

    // The backend uses multer upload.fields middleware which expects 'voucherData' in form-data
    if (!(data instanceof FormData)) {
      payload = new FormData();
      payload.append('voucherData', JSON.stringify(data));
      headers = { 'Content-Type': 'multipart/form-data' };
    }

    const response = await api.put(`/agent/vouchers/${id}`, payload, { headers });
    return response.data;
  },

  // Delete a voucher
  deleteVoucher: async (voucherId) => {
    const response = await api.delete(`/agent/vouchers/${voucherId}`);
    return response.data;
  },

  // Download voucher PDF / blob
  downloadVoucherPdf: async (voucherId, type = 'download') => {
    const response = await api.get(`/agent/download-voucher?id=${voucherId}&type=${type}`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Get guests associated with a voucher
  getVoucherGuests: async (id) => {
    const response = await api.get(`/agent/vouchers/${id}/guests`);
    return response.data;
  },

  // Get reservations for a voucher
  getVoucherReservations: async (id) => {
    const response = await api.get(`/agent/vouchers/${id}/reservations`);
    return response.data;
  },

  // Check booking ID availability
  checkBookingId: async (bookingId, params = {}) => {
    const cleanId = String(bookingId).replace(/^\/agent\/vouchers\/check-id\//, '');
    const response = await api.get(`/agent/vouchers/check-id/${cleanId}`, { params });
    return response.data;
  },

  // Upload an important document for a voucher
  uploadImportantDocument: async (voucherId, formData) => {
    const response = await api.post(`/agent/vouchers/${voucherId}/important-documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Delete an important document from a voucher
  deleteImportantDocument: async (voucherId, docId) => {
    const response = await api.delete(`/agent/vouchers/${voucherId}/important-documents/${docId}`);
    return response.data;
  },

  // Ping traveller via WhatsApp / SMS
  pingTraveller: async (payload) => {
    const response = await api.post('/notifications/ping', payload);
    return response.data;
  },

  // Upload single file / image
  uploadSingle: async (formData) => {
    const response = await api.post('/upload/single', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Get agent locations
  getLocations: async () => {
    const response = await api.get('/agent/locations');
    return response.data;
  }
};

export default voucherService;
